import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import React, { Suspense } from 'react';
import Layout from './components/Layout/Layout';

import { createApolloClient } from './lib/apollo';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';
import { ErrorBoundary } from './components/ErrorBoundary/ErrorBoundary';
import { LoadingSpinner } from './components/LoadingSpinner/LoadingSpinner';
import { useHealthCheck } from './hooks/useHealthCheck';
import HealthWarning from './components/HealthWarning/HealthWarning';

// Lazy load route components
const Welcome = React.lazy(() => import('./components/Welcome/Welcome'));
const Login = React.lazy(() => import('./components/Login/Login'));

// Lazy load questionnaire feature components
const QuestionnaireFeature = React.lazy(() =>
  import('./features/questionnaire/QuestionnaireRoutes').then(module => ({
    default: module.QuestionnaireRoutes
  }))
);


function App() {
  const client = createApolloClient();
  const { showWarning, setShowWarning } = useHealthCheck();

  return (
    <ErrorBoundary>
      <ApolloProvider client={client}>
        <AuthProvider>
          <Router>
            <Layout>
              <div className="min-h-screen bg-gray-100">
                <main>
                  <Suspense fallback={<LoadingSpinner />}>
                    <Routes>
                    <Route path="/" element={<Navigate to="/welcome" replace />} />
                    <Route path="/welcome" element={<Welcome />} />
                    {/* Redirect /login to /signup since signup is our primary flow */}
                    <Route path="/login" element={<Navigate to="/signup" replace />} />
                    {/* Both signin and signup use the Login component */}
                    <Route path="/signin" element={<Login />} />
                    <Route path="/signup" element={<Login />} />
                    <Route
                      path="/questionnaire/*"
                      element={
                        <ProtectedRoute>
                          <QuestionnaireFeature />
                        </ProtectedRoute>
                      }
                    />
                    <Route path="*" element={<div>404 - Not Found</div>} />
                  </Routes>
                </Suspense>
                {showWarning && (
                  <HealthWarning onClose={() => setShowWarning(false)} />
                )}
              </main>
            </div>
            </Layout>
          </Router>
        </AuthProvider>
      </ApolloProvider>
    </ErrorBoundary>
  );
}

export default App;